import { render } from "./AttivitaNode.vue?vue&type=template&id=14500bea&scoped=true"
import script from "./AttivitaNode.vue?vue&type=script&lang=js"
export * from "./AttivitaNode.vue?vue&type=script&lang=js"

import "./AttivitaNode.vue?vue&type=style&index=0&id=14500bea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14500bea"]])

export default __exports__